<template>
  <div class="flex flex-col min-h-screen">
    <main class="flex-grow flex flex-col">
      <slot />
    </main>
  </div>
</template>
